export const BASEMAP = "BASEMAP";
export const BASEMAPASLI = "BASEMAPASLI";
export const BASEMAPLEGEND = "BASEMAPLEGEND";
export const DATEVERSION = "DATEVERSION";
export const ZOOM = "ZOMM";
export const LONGLAT = "LONGLAT";
export const CHECKEDPOI = "CHECKEDPOI";
export const SHIPFINDER = "SHIPFINDER";
export const POIPASENGER = "POIPASENGER";
export const POICONTENT = "POICONTENT";
export const MEASURESTAT = "MEASURESTAT";
export const LONLATMOUSE = "LONLATMOUSE";
export const DRAWTYPE = "DRAWTYPE";
export const DRAWDATA = "DRAWDATA";
export const DRAWDATAALL = "DRAWDATAALL";
export const POITARGET = "POITARGET";
export const ZONATARGET = "ZONATARGET";
export const PORTTARGET = "PORTTARGET";
export const POIINFOEXPAND = "POIINFOEXPAND";
export const DISTINCTCHECK = "DISTINCTCHECK";
export const POINTSHIPTRACK = "POINTSHIPTRACK";
export const VESSELPOINTTRACK = "VESSELPOINTTRACK";
export const ACTIVEDRAWING = "ACTIVEDRAWING";
export const ACTIVETRACKING = "ACTIVETRACKING";
export const ACTIVESEARCHING = "ACTIVESEARCHING";
export const CENTERLINE = "CENTERLINE";
export const VESSELSELECTED = "VESSELSELECTED";
export const RADIUSGEOM = "RADIUSGEOM";
export const LAYERADD = "LAYERADD";
export const POISELECTED = "POISELECTED";
export const EARTHQUAKE = "EARTHQUAKE";
export const VESSELPTMCHECKED = "VESSELPTMCHECKED";
export const ALLSTATEMAPMASTER = "ALLSTATEMAPMASTER";
export const FILTER = "FILTER";
export const SHIPTRACK = "SHIPTRACK";
export const SHIPTRACK2 = "SHIPTRACK2";
export const SOURCEAIS = "SOURCEAIS";
export const WEATHERCHECKED = "WEATHERCHECKED";
export const BATHYMETRYCHECKED = "BATHYMETRYCHECKED";
export const VIDEODATA = "VIDEODATA";
export const SEARCHVESSEL = "SEARCHVESSEL";
export const DIALOGSEARCH = "DIALOGSEARCH";
export const SHIPFRAUD = "SHIPFRAUD";
export const SPEEDTARGET = "SPEEDTARGET";

export function pushShipFraud(values) {
  return {
    type: SHIPFRAUD,
    payload: values
  };
}

export function pushDialogSearch(values) {
  return {
    type: DIALOGSEARCH,
    payload: values
  };
}

export function pushSearchVessel(values) {
  return {
    type: SEARCHVESSEL,
    payload: values
  };
}

export function pushVideoData(values) {
  return {
    type: VIDEODATA,
    payload: values
  };
}

export function pushWeatherChecked(values) {
  return {
    type: WEATHERCHECKED,
    payload: values
  };
}

export function pushBathymetryChecked(values) {
  return {
    type: BATHYMETRYCHECKED,
    payload: values
  };
}

export function pushSourceAis(values) {
  return {
    type: SOURCEAIS,
    payload: values
  };
}

export function pushShipTrack(values) {
  return {
    type: SHIPTRACK,
    payload: values
  };
}

export function pushShipTrack2(values) {
  return {
    type: SHIPTRACK2,
    payload: values
  };
}

export function pushFilter(values) {
  return {
    type: FILTER,
    payload: values
  };
}

export function pushAllStateMapmaster(values) {
  return {
    type: ALLSTATEMAPMASTER,
    payload: values
  };
}

export function pushVesselPtmSelected(values) {
  return {
    type: VESSELPTMCHECKED,
    payload: values
  };
}

export function pushEarthQuake(values) {
  return {
    type: EARTHQUAKE,
    payload: values
  };
}

export function pushLayerAdd(values) {
  return {
    type: LAYERADD,
    payload: values
  };
}

export function pushRadiusGeom(values) {
  return {
    type: RADIUSGEOM,
    payload: values
  };
}

export function pushCenterLine(values) {
  return {
    type: CENTERLINE,
    payload: values
  };
}

export function pushActiveDrawing(values) {
  return {
    type: ACTIVEDRAWING,
    payload: values
  };
}

export function pushActiveTracking(values) {
  return {
    type: ACTIVETRACKING,
    payload: values
  };
}

export function pushPointActiveSearching(values) {
  return {
    type: ACTIVESEARCHING,
    payload: values
  };
}

export function pushPointShipTrack(values) {
  return {
    type: POINTSHIPTRACK,
    payload: values
  };
}

export function pushVesselPointTrack(values) {
  return {
    type: VESSELPOINTTRACK,
    payload: values
  };
}

export function pushDistCheck(values) {
  return {
    type: DISTINCTCHECK,
    payload: values
  };
}

export function pushPoiTarget(values) {
  return {
    type: POITARGET,
    payload: values
  };
}

export function pushSpeedTarget(values) {
  return {
    type: SPEEDTARGET,
    payload: values
  };
}
export function pushPoiInfoExpand(values) {
  return {
    type: POIINFOEXPAND,
    payload: values
  };
}

export function pushPortTarget(values) {
  return {
    type: PORTTARGET,
    payload: values
  };
}

export function pushZonaTarget(values) {
  return {
    type: ZONATARGET,
    payload: values
  };
}

export function pushBasemap(values) {
  return {
    type: BASEMAP,
    payload: values
  };
}

export function pushDrawData(values) {
  return {
    type: DRAWDATA,
    payload: values
  };
}

export function pushDrawDataAll(values) {
  return {
    type: DRAWDATAALL,
    payload: values
  };
}

export function pushLonlatMouse(values) {
  return {
    type: LONLATMOUSE,
    payload: values
  };
}

export function pushBasemapasli(values) {
  return {
    type: BASEMAPASLI,
    payload: values
  };
}

export function pushBasemapLegend(values) {
  return {
    type: BASEMAPLEGEND,
    payload: values
  };
}

export function pushDateVersion(values) {
  return {
    type: DATEVERSION,
    payload: values
  };
}

export function pushZoom(values) {
  return {
    type: ZOOM,
    payload: values
  };
}

export function pushLongLat(values) {
  return {
    type: LONGLAT,
    payload: values
  };
}

export function pushCheckedPOI(values) {
  return {
    type: CHECKEDPOI,
    payload: values
  };
}

export function pushShipFinder(values) {
  return {
    type: SHIPFINDER,
    payload: values
  };
}

export function pushPoiPasenger(values) {
  return {
    type: POIPASENGER,
    payload: values
  };
}

export function pushPoiContent(values) {
  return {
    type: POICONTENT,
    payload: values
  };
}

export function pushMeasureStat(values) {
  return {
    type: MEASURESTAT,
    payload: values
  };
}

export function pushDrawType(values) {
  return {
    type: DRAWTYPE,
    payload: values
  };
}

export function pushVesselSelected(values) {
  return {
    type: VESSELSELECTED,
    payload: values
  };
}

export function pushPoiSelected(values) {
  return {
    type: POISELECTED,
    payload: values
  };
}
